/** Syngenta design-system scales. Single source for `tailwind.config.ts` and the Antd v6 theme. */
export const palette = {
  white: '#FFFFFF',
  black: '#000000',
  blue: {
    10: '#EAF6FF',
    20: '#C6E6FF',
    30: '#82cfff',
    40: '#005693',
    50: '#0092E4',
    60: '#0071CD',
    70: '#005693',
    80: '#003B69',
    90: '#002747',
  },
  neutral: {
    10: '#F3F4F6',
    20: '#DFE2E7',
    30: '#C2C7D0',
    40: '#A3A9B9',
    50: '#868CA2',
    60: '#696F88',
    70: '#4D5165',
    80: '#363948',
    90: '#232630',
    100: '#14151C',
  },
  /** The second grey ramp, mirroring `--gray-*` in `sass/base/_colors.module.scss`. */
  gray: {
    10: '#2F3031',
    30: '#707374',
    40: '#C1C5C8',
    50: '#F5F8FC',
  },
  cyan: {
    10: '#E1FDFE',
    20: '#C3FAFD',
    30: '#8FF7FB',
    40: '#49EAF2',
    50: '#00D2DF',
    60: '#00A8B8',
    70: '#00808C',
    80: '#00636C',
    90: '#004A4F',
    100: '#003536',
  },
  yellow: {
    10: '#FFF3DD',
    20: '#FFE4AE',
    30: '#F0C355',
    40: '#E99921',
    50: '#C17E19',
    60: '#9A6412',
    70: '#744A0B',
    80: '#523305',
  },
  green: {
    10: '#e1f5e8',
    20: '#C3EAD1',
    40: '#5EBB7F',
    50: '#19A04B',
    60: '#14803C',
    70: '#0C612C',
    80: '#06431C',
  },
  pink: {
    10: '#FFF1F3',
    60: '#BB485D',
  },
  red: {
    10: '#FFF1F1',
    20: '#FFD9D9',
    30: '#ffb3b3',
    40: '#F98989',
    50: '#EB4B4B',
    60: '#CF3537',
    70: '#9C2628',
    90: '#4C0E0F',
  },
  orange: {
    10: '#FFF1ED',
    60: '#C1462B',
    70: '#92331E',
  },
  teal: {
    10: '#E0F9F7',
    20: '#A9EFE8',
    30: '#5FD2C8',
    40: '#46BBB0',
    50: '#2B9C92',
    60: '#217C74',
    70: '#165C56',
    80: '#0D413C',
    90: '#062B27',
    100: '#021917',
  },
  purple: {
    20: '#E7DDFC',
    50: '#9664F0',
    60: '#8354D6',
    100: '#1C0D35',
  },
} as const;
